exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hotel-form-page .ota-names[data-v-499dba59]{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:5px}.hotel-form-page .ota-names .ota-label[data-v-499dba59]{width:48px}.hotel-form-page .ota-names .ota-input[data-v-499dba59]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.hotel-form-page .wxwork-names[data-v-499dba59]{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:5px}.hotel-form-page .wxwork-names .wxwork-label[data-v-499dba59]{width:85px}.hotel-form-page .wxwork-names .wxwork-input[data-v-499dba59]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}\n", ""]);

// exports
